var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionIconThickGrey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.0401 0 0 4.0401 0 9C0 13.9599 4.0401 18 9 18C13.9599 18 18 13.9599 18 9C18 4.0401 13.9599 0 9 0ZM9 1.8C12.9871 1.8 16.2 5.01289 16.2 9C16.2 12.9871 12.9871 16.2 9 16.2C5.01289 16.2 1.8 12.9871 1.8 9C1.8 5.01289 5.01289 1.8 9 1.8ZM9 3.6C7.011 3.6 5.4 5.211 5.4 7.2H7.2C7.2 6.21 8.01 5.4 9 5.4C9.99 5.4 10.8 6.21 10.8 7.2C10.8 9 8.1 9.3303 8.1 11.7H9.9C9.9 10.2141 12.6 9.45 12.6 7.2C12.6 5.211 10.989 3.6 9 3.6ZM8.1 12.6V14.4H9.9V12.6H8.1Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIconThickGrey);
export default __webpack_public_path__ + "static/media/question-icon-thick-grey.67093af271277fbac3beaba83b80f2bf.svg";
export { ForwardRef as ReactComponent };